import React from "react";
import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import useDeliveryData from "./hooks/useDeliveryData";
import BikerTransactions from "./components/BikerTransactions";
import HelpSupportButton from "../../components/HelpSupportButton";
import TopNav from "../../components/top-nav";
import DeliveryLayout from "./DeliveryLayout";

const BikerTransactionsPage = () => {
    const {
        transactions,
        transactionPagination,
        loading,
        updateTransactionFilters,
        getTransactionHistory,
    } = useDeliveryData();

    const spinnerIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;

    const handlePageChange = (page, pageSize) => {
        updateTransactionFilters({ page, limit: pageSize });
    };

    return (
        <>
            <DeliveryLayout>
                <div className="wise9ja-content">
                    <div>
                        <Spin indicator={spinnerIcon} spinning={loading}>
                            <div className="homepage wise9ja-disp">
                                <div className="homepage-history-header">
                                    <TopNav title="Transactions" />
                                </div>
                                <div className="hero-sect mt_2"></div>
                                <div className="content-display-content">
                                    <div className="contain">
                                        <div className="wise9ja-action-bar"></div>
                                        <BikerTransactions
                                            transactions={transactions}
                                            pagination={transactionPagination}
                                            loading={loading}
                                            onRefresh={getTransactionHistory}
                                            onPageChange={handlePageChange}
                                        />
                                    </div>
                                </div>
                            </div>
                        </Spin>
                    </div>
                </div>
            </DeliveryLayout>
            <HelpSupportButton page="DRIVER_HOME" />
        </>
    );
};

export default BikerTransactionsPage;
